module.exports = __webpack_public_path__ + "static/media/ops-icon.588414f8.png";